/**
 * 官网接口
 * ***/

import request from "@/utils/request";

// 访客新增
export function visitorlogApi(query) {
  return request({
    url: "/dnn/openapi/visitorlog/save",
    method: "post",
    data: query,
  });
}

// 首页banner
export function bannerListApi() {
  return request({
    url: "/dnn/openapi/banner/list",
    method: "get",
  });
}

// 资讯管理3条
export function infoTopThreeApi() {
  return request({
    url: "/dnn/openapi/informationmanage/list",
    method: "get",
  });
}

// 资讯管理
export function infoManageApi(query) {
  return request({
    url: "/dnn/openapi/informationmanage/page",
    method: "get",
    params: query,
  });
}

// 资讯详情
export function newsDetailApi(query) {
  return request({
    url: "/dnn/openapi/informationmanage/detail",
    method: "get",
    params: query,
  });
}

// 狄诺尼产品列表
export function productListApi() {
  return request({
    url: "/dnn/openapi/product/list",
    method: "get",
  });
}

// 客户咨询
export function saveConsultInfoApi(query) {
  return request({
    url: "/dnn/openapi/customerconsultation/save",
    method: "post",
    data: query,
  });
}

// 产品查询所有软件
export function softwareByProductApi(query) {
  return request({
    url: "/dnn/openapi/software/detail",
    method: "get",
    params: query,
  });
}

// 狄诺尼学院视频表
export function collegevideoListApi() {
  return request({
    url: "/dnn/openapi/collegevideo/list",
    method: "get",
  });
}

// 所有软件与软件手册
export function softwareAllApi() {
  return request({
    url: "/dnn/openapi/software/all",
    method: "get",
  });
}

// 下载统计
export function downLoadCount(query) {
  return request({
    url: "/dnn/openapi/operation/record",
    method: "get",
    params: query,
  });
}
